import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/Home";
import ProductDetail from "./pages/ProductDetail";
import ReferencesPage from "./pages/ReferencesPage";
import Admin from "./pages/Admin";
import { I18nProvider } from "./context/I18nContext";

function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/urun/:slug" element={<ProductDetail />} />
          <Route path="/referanslar" element={<ReferencesPage />} />
          <Route path="/kai" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
